export {
    tableReportSliceActions,
} from './table-report-slice';
